<template>
    <b-form submite.stop.prevent="save">
        <div class="radio-configuration">
            <label>{{ $t('opcao-de-configuracao') }}:</label>
            <div class="radio-buttons">
                <b-form-radio v-model="selectedType" value="turno">{{
                    $t('turno') }}</b-form-radio>
                <b-form-radio v-model="selectedType" value="diario">{{
                    $t('diario') }}</b-form-radio>
            </div>
        </div>
        <div class="radio-container">
            <label>{{ $t('campo-a-ser-prevalecido') }}:</label>
            <div class="radio-buttons">
                <b-form-radio v-model="selectedFieldToMilling" value="minimumMillingQuantityPerShift">{{
                    $t('quantidade-minima-de-moagem') }}</b-form-radio>
                <b-form-radio v-model="selectedFieldToMilling" value="minimumMillingHoursPerShift">{{
                    $t('quantidade-minima-de-horas-de-moagem') }}</b-form-radio>
            </div>
        </div>
        <div v-if="selectedFieldToMilling == 'minimumMillingQuantityPerShift' && selectedType == 'turno'" class="mt-3">
            <label :title="$t('quantidade-minima-de-moagem-no-turno-t')">{{ $t('quantidade-minima-de-moagem-no-turno-t')
                }}:</label>
            <input type="number" min="1" max="3" v-model.lazy="minimumMillingQuantityPerShift"
                id="minimumMillingQuantityPerShift" />
        </div>
        <div v-if="selectedFieldToMilling == 'minimumMillingHoursPerShift' && selectedType == 'turno'" class="mt-3">
            <label :title="$t('quantidade-minima-de-horas-de-moagem-no-turno')">{{
                $t('quantidade-minima-de-horas-de-moagem-no-turno') }}:</label>
            <input type="number" min="0" step="0.5" id="minimumMillingHoursPerShift"
                v-model="minimumMillingHoursPerShift" />
        </div>
        <div v-if="selectedFieldToMilling == 'minimumMillingQuantityPerShift' && selectedType == 'diario'" class="mt-3">
            <label :title="$t('quantidade-minima-de-moagem-diaria-t')">{{ $t('quantidade-minima-de-moagem-diaria-t')
                }}:</label>
            <input type="number" min="1" max="3" v-model.lazy="minimumMillingQuantityPerDaily"
                id="minimumMillingQuantityPerDaily" />
        </div>
        <div v-if="selectedFieldToMilling == 'minimumMillingHoursPerShift' && selectedType == 'diario'" class="mt-3">
            <label :title="$t('quantidade-minima-de-horas-de-moagem-diaria')">{{
                $t('quantidade-minima-de-horas-de-moagem-diaria') }}:</label>
            <input type="number" min="0" step="0.5" id="minimumMillingHoursPerDaily"
                v-model="minimumMillingHoursPerDaily" />
        </div>
        <div class="mt-3">
            <label :title="$t('acionar-os-gatilhos-antes-do-final-do-turno-min')">{{
                $t('acionar-os-gatilhos-antes-do-final-do-turno-min') }}:</label>
            <input type="number" min="0" step="0.5" id="triggerBeforeWorkShift" v-model="triggerBeforeWorkShift" />
            <hr />
        </div>
        <b-row class="groupBtn">
            <div>
                <img src="@/assets/salvar.png" alt="salvar" :title="$t('save')" @click="saveMillingSettingToTrigger" />
                <img id="closeModalPassword" src="@/assets/sair.png" style="margin-left: 15px" :title="$t('exit')"
                    alt="Sair" @click="$bvModal.hide('modalTriggerMillingsSetting')" />
            </div>
        </b-row>
    </b-form>
</template>

<script>
import { defaultSuccess, urlMainAPI } from "@/global";
import axios from "axios";
import { FiltersMixin } from "../../mixins/filtersMixin";
export default {
    name: "ModalMillingSetting",
    mixins: [FiltersMixin],
    data() {
        return {
            minimumMillingQuantityPerShift: 0,
            minimumMillingHoursPerShift: 0,
            minimumMillingQuantityPerDaily: 0,
            minimumMillingHoursPerDaily: 0,
            triggerBeforeWorkShift: 0,
            systemConfig: null,
            selectedFieldToMilling: 'minimumMillingQuantityPerShift',
            selectedType: 'turno',
            fieldOptions: [
                { value: 'minimumMillingQuantityPerShift', text: this.$t('quantidade-minima-de-moagem-no-turno-t') },
                { value: 'minimumMillingHoursPerShift', text: this.$t('quantidade-minima-de-horas-de-moagem-no-turno') },
                { value: 'triggerBeforeWorkShift', text: this.$t('acionar-os-gatilhos-antes-do-final-do-turno-min') }
            ]
        };
    },
    methods: {
        async getMillingSettingToTrigger() {
            const url = `${urlMainAPI}/getsystemconfiguration`;
            await axios
                .get(url)
                .then((res) => {
                    this.systemConfig = res.data;
                    this.minimumMillingQuantityPerShift = res.data.minimumMillingQuantityPerShift;
                    this.minimumMillingHoursPerShift = res.data.minimumMillingHoursPerShift;
                    this.minimumMillingQuantityPerDaily = res.data.minimumMillingQuantityPerDaily;
                    this.minimumMillingHoursPerDaily = res.data.minimumMillingQuantityPerDaily;
                    this.triggerBeforeWorkShift = res.data.triggerBeforeWorkShift;
                    this.selectedFieldToMilling = res.data.selectedFieldToMilling;
                })
                .catch();
        },

        async saveMillingSettingToTrigger() {
            let obj = this.systemConfig
            obj.minimumMillingQuantityPerShift = parseInt(this.minimumMillingQuantityPerShift)
            obj.minimumMillingHoursPerShift = parseInt(this.minimumMillingHoursPerShift)
            obj.minimumMillingQuantityPerDaily = parseInt(this.minimumMillingQuantityPerDaily)
            obj.minimumMillingHoursPerDaily = parseInt(this.minimumMillingHoursPerDaily)
            obj.triggerBeforeWorkShift = parseInt(this.triggerBeforeWorkShift)
            obj.selectedFieldToMilling = this.selectedFieldToMilling
            const url = `${urlMainAPI}/saveconfigmillinginfo`;
            await axios
                .post(url, obj)
                .then(() => {
                    defaultSuccess(this.$t('configuracoes-salvas-com-sucesso'));
                    this.systemConfig = JSON.parse(JSON.stringify(obj));
                    this.minimumMillingQuantityPerShift = obj.minimumMillingQuantityPerShift;
                    this.minimumMillingHoursPerShift = obj.minimumMillingHoursPerShift;
                    this.minimumMillingQuantityPerDaily = obj.minimumMillingQuantityPerDaily;
                    this.minimumMillingHoursPerDaily = obj.minimumMillingHoursPerDaily;
                    this.triggerBeforeWorkShift = obj.triggerBeforeWorkShift;
                    this.selectedFieldToMilling = obj.selectedFieldToMilling;
                })
                .catch();
        },
    },

    async created() {
        await this.getMillingSettingToTrigger();
    }
};
</script>

<style scoped>
.card {
    padding: 5px;
}

.row {
    display: block;
}

.groupBtn {
    display: flex;
    justify-content: flex-end;
    margin-right: 0px;
}

img {
    cursor: pointer;
    max-height: 35px;
    margin-top: 15px;
}

input {
    float: right;
    min-width: 180px;
    width: 250px;
    text-align: center;
    border: 1px solid #ff5f00;
    border-radius: 3px;
}

input:focus {
    box-shadow: 0px 0px 5px #ff5f00;
    outline: 0;
}

.radio-container {
    display: grid;
    grid-template-columns: auto auto;
    align-items: center;
}

.radio-configuration {
    display: grid;
    grid-template-columns: auto auto;
    align-items: center;
    margin-bottom: 15px;
}

.radio-buttons {
    grid-column: 2;
    display: flex;
    justify-content: space-around;
}

@media (max-width: 427px) {
    .d-flex.mobile {
        display: block !important;
    }
}
</style>